import React, { useEffect, useRef } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { getDomDistance, getQuery } from '@src/utils/index';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

const Banner = () => {
    const imgRef = useRef();
    const bannerImgUrl = window.allData?.
        modules[0]?.data?.articleList[0]?.thumbnail || 'https://x0.ifengimg.com/feprod/c/2024_9_6/17_27_37/941725605969_.pic.jpg';
    const infoImgUrl = window.allData?.
        modules[1]?.data?.articleList[0]?.thumbnail || 'https://x0.ifengimg.com/feprod/c/2024_9_10/15_11_19/8066E471430A5389558CB8642B2EA53A8BE9273F_size52_w1005_h492.png';

    useEffect(() => {
        const bannerImgObj = new Image();

        bannerImgObj.onload = () => {
            const fromWecom = getQuery(location.href, 'from_wecom');
            const domPageTop = getDomDistance(imgRef.current).top;

            if (domPageTop && fromWecom === '1') {
                window.scroll({ top: domPageTop, behavior: 'smooth' });
            }
        };

        bannerImgObj.src = bannerImgUrl;
    }, []);

    return (
        <div className={styles.banner}>
            <img
                src={bannerImgUrl}
                className={styles.banner1}
            />
            <div className={styles.bref}>
                <img
                    ref={imgRef} 
                    // src="https://x0.ifengimg.com/ucms/2024_29/D5512A9FF06295C9129AB7BFDBBDFC352773A906_size60_w670_h328.png"
                    src={infoImgUrl}
                    className={styles.banner2}
                />
            </div>
        </div>
    );
};

export default errorBoundary(Banner);
